module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-container"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imagePaths.mobile),
      expression: "imagePaths.mobile"
    }],
    staticClass: "d-block d-sm-none",
    attrs: {
      "alt": _vm.altText
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imagePaths.desktop),
      expression: "imagePaths.desktop"
    }],
    staticClass: "d-none d-sm-block",
    attrs: {
      "alt": _vm.altText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "opacity"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center justify-content-md-start"
  }, [_c('div', {
    staticClass: "col-10 col-md-8 col-xl-5 text-center text-md-left"
  }, [_vm._t("content"), _vm._v(" "), _c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/get-start?step=1",
      "tag": "button"
    }
  }, [_vm._v("Get a quote")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ad21a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/HeroFull.vue
// module id = 2002
// module chunks = 5